import type { TFunction } from 'i18next';

import type { MarketingAreaId } from './areas';

/**
 * Each Marketing area's name and one-line description, for the hub cards and the area header. Literal `t()` calls per
 * case, so the extractor harvests every key (the names are the section's former tab labels); the `switch` is
 * exhaustive, so a new area fails the typecheck until it has its copy.
 */

export const marketingAreaTitle = (t: TFunction, id: MarketingAreaId): string => {
  switch (id) {
    case 'banner-kits':
      return t('Image Banners');
    case 'html5-banners':
      return t('HTML5 Banners');
    case 'videos':
      return t('Video Ads');
    case 'playables':
      return t('Mini-games');
    case 'landing-pages':
      return t('Landing Pages');
  }
};

export const marketingAreaDescription = (t: TFunction, id: MarketingAreaId): string => {
  switch (id) {
    case 'banner-kits':
      return t('One ad, ready in every size.');
    case 'html5-banners':
      return t('Animated banners, ready for ad networks.');
    case 'videos':
      return t('Short videos for social and ad networks.');
    case 'playables':
      return t('Playable ads players try in one tap.');
    case 'landing-pages':
      return t('Pages on your own domain that turn clicks into players.');
  }
};
